import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-3">
          <div className="flex items-center justify-center space-x-2 text-sm text-gray-600">
            <span>Powered by</span>
            <a
              href="https://www.lizzardsolutions.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-gray-800 hover:text-purple-600 transition-colors flex items-center space-x-1"
            >
              <span>Lizzard Solutions</span>
              <svg
                className="h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

